import {
  ButtonTertiary,
  PopoverNavigation,
  PopoverNavigationItem,
  cssColorValue,
  desktopBallad,
  desktopCello,
  desktopMesto,
  semanticColors,
  spacer12,
  spacer16,
  spacer32,
  spacer4,
  spacer8,
} from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

export const NavBarPopoverListTitle = styled.span`
  color: ${cssColorValue(semanticColors.textBase)};
  cursor: default;
  ${desktopCello};
`;

export const NavBarPopoverList = styled.ul`
  cursor: default;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin-top: ${spacer16};
  padding: 0;
`;

export const NavBarPopoverNavigation = styled(PopoverNavigation)`
  max-inline-size: none;
  padding: ${spacer12};
`;

export const NavBarPopoverNavigationItem = styled(PopoverNavigationItem)<{
  isDisabled?: boolean;
}>`
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.3' : '1')};
`;

export const NavBarPopoverLinkIconLeadingWrapper = styled.span`
  background-color: ${cssColorValue(semanticColors.backgroundTintedBase)};
  border-radius: ${spacer4};
  display: inline-flex;
  padding: ${spacer8};
`;

export const NavBarPopoverLinkIconLeadingImage = styled.img<{
  imgUrl: string;
}>`
  background-color: ${cssColorValue(semanticColors.textSubdued)};
  mask: ${({ imgUrl }) => `url(${imgUrl}) no-repeat center`};
  height: ${spacer16};
  width: ${spacer16};
`;

export const NavBarPopoverLinkText = styled.span<{
  isDisabled?: boolean;
}>`
  & {
    color: ${({ isDisabled }) =>
      isDisabled ? cssColorValue(semanticColors.textSubdued) : cssColorValue(semanticColors.textBase)};
  }
`;

export const NavBarPopoverLinkSubText = styled.span`
  & {
    color: ${cssColorValue(semanticColors.textSubdued)};
    white-space: nowrap;
    ${desktopMesto};
  }
`;

export const NavBarPopoverLink = styled(ButtonTertiary)<{
  level?: number;
}>`
  color: ${cssColorValue(semanticColors.textSubdued)};
  justify-content: flex-start;
  min-height: 32px;
  padding-block: ${spacer8};
  padding-inline: 0;
  gap: ${spacer12};
  width: 100%;
  ${desktopBallad};

  &:active,
  &:hover,
  &:focus {
    transform: none;
  }

  &:hover {
    color: ${cssColorValue(semanticColors.textBrightAccent)};

    & ${NavBarPopoverLinkText}, & ${NavBarPopoverLinkSubText} {
      color: ${cssColorValue(semanticColors.textBrightAccent)};
    }

    & ${NavBarPopoverLinkIconLeadingImage} {
      background-color: ${cssColorValue(semanticColors.textBrightAccent)};
    }
  }

  &:active {
    color: ${cssColorValue(semanticColors.textBase)};
    opacity: 1;
  }

  & > * {
    margin: 0;
  }

  &::after {
    bottom: 0;
    inline-size: ${({ level, iconLeading }) => (!iconLeading && level === 2 ? `calc(100% - 32px)` : '100%')};
    margin-inline-start: ${({ level, iconLeading }) => (!iconLeading && level === 2 ? spacer32 : 0)};
  }
`;

export const NavBarPopoverLinkTextWrapper = styled.span<{
  iconLeading?: boolean;
  level?: number;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-inline-start: ${({ level, iconLeading }) => (!iconLeading && level === 2 ? spacer32 : 0)};
  text-align: start;
`;
